// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"6d26da55","43":"25886acb","47":"7dfd7187","81":"24076784","416":"dd3a4834","445":"4cb520b6","567":"33b5caff","602":"c4e61dcc","787":"946de56b","861":"32425425","972":"86db8885"}[chunkId] + ".chunk.js";
};